import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import EditIcon from "@material-ui/icons/Edit";
import ListItemText from "@material-ui/core/ListItemText";
import SettingsIcon from "@material-ui/icons/Settings";
import ExploreRoundedIcon from '@material-ui/icons/ExploreRounded';
import List from "@material-ui/core/List";
import {labelDashboardLeftMenu} from "./LabelDashboardMenu";

import {isMobile} from 'react-device-detect';


export default function DashboardLeftMenu(props) {

    const langPref = props.beagleLanguagePreference;
    const mathPref = props.beagleMathPreference;

    const labelCrops = labelDashboardLeftMenu.labelCrops[langPref];
    const labelSettings = labelDashboardLeftMenu.labelSettings[langPref];

    let labelSettingsSecondary = labelDashboardLeftMenu.labelMathPref.m[langPref];
    if (mathPref === 'i') {
        labelSettingsSecondary = labelDashboardLeftMenu.labelMathPref.i[langPref];
    }

    const labelAbout = labelDashboardLeftMenu.labelAbout[langPref];

    const iconFontSize = isMobile ? "small" : "large";


    return (
        <List>
            <div>
                <ListItem
                    button
                    selected={props.dashboardPageIndex === 1}
                    onClick={(event) => props.handleDashboardPageIndex(event, 1)}>
                    <ListItemIcon>
                        <EditIcon fontSize={iconFontSize}/>
                    </ListItemIcon>
                    <ListItemText primary={labelCrops}/>
                </ListItem>
                <ListItem
                    button
                    selected={props.dashboardPageIndex === 2}
                    onClick={(event) => props.handleDashboardPageIndex(event, 2)}>
                    <ListItemIcon>
                        <SettingsIcon fontSize={iconFontSize}/>
                    </ListItemIcon>
                    <ListItemText primary={labelSettings} secondary={labelSettingsSecondary}/>
                </ListItem>
                <ListItem
                    button
                    selected={props.dashboardPageIndex === 3}
                    onClick={(event) => props.handleDashboardPageIndex(event, 3)}>
                    <ListItemIcon>
                        <ExploreRoundedIcon fontSize={iconFontSize}/>
                    </ListItemIcon>
                    <ListItemText primary={labelAbout}/>
                </ListItem>
            </div>
        </List>
    );
}
